import { CloudAuthApi } from "./api.cloud";
import { BoxAuthApi } from "./api.box";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseAuthApi } from "./api.base";
import environment from "@/config";

export default getService<BaseAuthApi>(environment.nexus, {
    box: new BoxAuthApi(),
    cloud: new CloudAuthApi(),
});